import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=00a67164&scoped=true&"
import script from "./Header.vue?vue&type=script&setup=true&lang=js&"
export * from "./Header.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a67164",
  null
  
)

export default component.exports